import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const audiencePoints = [{
  content: <>
        Amas el café, pero{' '}
        <span style={{
      color: '#7A2E2E'
    }} data-id="element-140">
          no lográs prepararlo
        </span>{' '}
        como <span className="font-semibold" data-id="element-141">realmente te gustaría</span>.
      </>
}, {
  content: <>
        Te gustaría transformar tu pasión por el café en un{' '}
        <span className="font-semibold" data-id="element-142">negocio rentable</span>, pero{' '}
        <span style={{
      color: '#7A2E2E'
    }} data-id="element-143">
          no sabés por dónde empezar
        </span>
        .
      </>
}, {
  content: <>
        <span className="font-semibold" data-id="element-144">Probaste recetas</span> de YouTube o
        Instagram, pero{' '}
        <span style={{
      color: '#7A2E2E'
    }} data-id="element-145">
          ninguna te quedó bien
        </span>
        .
      </>
}];
export function TargetAudienceSection() {
  return <section className="py-10 bg-cream" data-id="element-146">
      <div className="max-w-2xl mx-auto px-6" data-id="element-147">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-serif text-coffee-dark text-center mb-8" data-id="element-148">
          Este libro digital es para ti si...
        </motion.h2>

        <div className="space-y-3" data-id="element-149">
          {audiencePoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start gap-4 bg-white/50 border border-coffee-light/15 rounded-xl p-4" data-id="element-150">
              <div className="w-8 h-8 rounded-full bg-coffee-light/20 flex items-center justify-center shrink-0" data-id="element-151">
                <Check className="w-4 h-4 text-coffee" data-id="element-152" />
              </div>
              <p className="text-coffee-dark/80 text-sm leading-relaxed pt-1" data-id="element-153">
                {point.content}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}